import { render, staticRenderFns } from "./TheDynamicLayout.vue?vue&type=template&id=054013ce"
import script from "./TheDynamicLayout.vue?vue&type=script&lang=js"
export * from "./TheDynamicLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports